import React from 'react';

import { Stack, Typography } from '@mui/material';

import { getStatusBodyText } from './getStatusBodyText';
import type { DisplayChange } from './types';

interface Props {
  change: DisplayChange;
}

export default function CompactChange({ change }: Props) {
  const bodyText = getStatusBodyText(change) ?? change.summary;

  return (
    <Stack spacing={0.25} sx={{ mb: 0.75, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={700}>
        {change.label}
      </Typography>
      <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
        {bodyText}
      </Typography>
    </Stack>
  );
}
